import { combineReducers } from 'redux';
import get from 'lodash/get';
import merge from 'lodash/merge';

import filtersReducer from '@redux/shared/reducers/filters.reducer';
import createMetadataReducer from '@redux/shared/reducers/createMetadata.reducer';

import {
  FREIGHT_DISPLAY_TYPES_FETCHED,
  FREIGHT_DISPLAY_TYPE_ADDED,
  FREIGHT_DISPLAY_TYPE_UPDATE,
} from './freightDisplayTypes.actions';

const freightDisplayTypesIdsReducer = (state = [], action) => {
  switch (action.type) {
    case FREIGHT_DISPLAY_TYPES_FETCHED:
      return get(action, 'payload.result', []);
    case FREIGHT_DISPLAY_TYPE_ADDED:
      return [...state, get(action, 'payload.result')];
    default:
      return state;
  }
};

const freightDisplayTypesByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case FREIGHT_DISPLAY_TYPES_FETCHED:
      return get(action, 'payload.entities.freightDisplayType', {});
    case FREIGHT_DISPLAY_TYPE_ADDED:
    case FREIGHT_DISPLAY_TYPE_UPDATE:
      return merge({}, state, get(action, 'payload.entities.freightDisplayType'));
    default:
      return state;
  }
};

const freightDisplayTypesReducer = combineReducers({
  byId: freightDisplayTypesByIdReducer,
  ids: freightDisplayTypesIdsReducer,
  filters: filtersReducer('freightDisplayTypesFilters'),
  metadata: createMetadataReducer('freightDisplayTypesMetadata'),
});

export default freightDisplayTypesReducer;
